<div class="modal-container">
  <h2 class="form-title" mat-dialog-title>{{data.selectedRow ? 'Edit Price Condition': 'Add Price Condition'}}</h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-grid">
    <!-- Description -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" placeholder="Enter description" maxlength="80" />
      <mat-error *ngIf="form.get('description')?.hasError('required')">
        Description is required
      </mat-error>
      <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
        Max 80 characters
      </mat-error>
    </mat-form-field>

    <!-- Variant Combination Chips with Autocomplete -->
    <mat-form-field appearance="outline" class="full-width" [ngClass]="{ 'disabled-chip-grid': isEdit }">
      <mat-label>Variant Combinations</mat-label>
      <mat-chip-grid #chipGrid [disabled]="isEdit" formControlName="variantCombination" aria-label="Variant input">
        <mat-chip-row *ngFor="let variant of selectedVariants" [removable]="!isEdit" (removed)="removeVariant(variant)">
          {{variant}} <!-- {{ displayValue(variant) }} -->
          <button matChipRemove *ngIf="!isEdit">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      </mat-chip-grid>
      <input matInput placeholder="Add Variant" [matChipInputFor]="chipGrid" [matAutocomplete]="autoVariant"
        [formControl]="variantCtrl" (matChipInputTokenEnd)="addVariantFromInput()"
        [disabled]="isEdit || (selectedVariants?.length || 0) >= 6"
        (blur)="form.get('variantCombination')!.markAsTouched()" />

      <mat-autocomplete #autoVariant="matAutocomplete" (optionSelected)="selectVariant($event)">
        <mat-option *ngFor="let option of variantSuggestions" [value]="option.key"
          [disabled]=" isEdit || selectedVariants.includes(option.value)||(selectedVariants?.length || 0) >= 6">
          {{ option.value }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('variantCombination')?.hasError('required')">
        variant required</mat-error>
      <mat-error *ngIf="!isEdit && selectedVariants.length > 6">
        max 6 allowed</mat-error>
    </mat-form-field>

    <!-- Price Type with value -->

    <div formArrayName="prices" class="full-width price-type-grid">
      <ng-container *ngFor="let row of prices.controls;
       let i = index">
        <div [formGroupName]="i" class="price-type-row">
          <!-- Price Type Dropdown -->
          <mat-form-field appearance="outline" class="type-cell">
            <mat-label>Price Type</mat-label>
            <mat-select formControlName="selectedType" [compareWith]="comparePriceType">
              <mat-option *ngFor="let pt of priceTypes" [value]="pt">
                {{ pt.name }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="row.get('selectedType')?.hasError('required')">
              Price Type is required.
            </mat-error>
          </mat-form-field>

          <!-- Price Value Input -->
          <mat-form-field appearance="outline" class="value-cell">
            <mat-label>Price</mat-label>
            <input matInput type="number" step="any" placeholder="Enter price" formControlName="priceValue"
              (keydown.enter)="$event.preventDefault()" required />
            <mat-error *ngIf="row.get('priceValue')?.hasError('required')">
              Price is required.
            </mat-error>

          </mat-form-field>

          <!-- Remove Button -->
          <div class="actions-cell" *ngIf="false">
            <button mat-icon-button color="warn" type="button" *ngIf="prices.length > 1" (click)="removePriceRow(i)">
              <mat-icon>remove_circle</mat-icon>
            </button>


            <!-- Add Button -->
            <button mat-icon-button color="primary" type="button" *ngIf="i === prices.length - 1"
              (click)="addPriceRow()">
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>

    </div>


    <!-- Valid From -->
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Valid From</mat-label>
      <input matInput [matDatepicker]="fromPicker" [min]="minDate" formControlName="validFrom" />
      <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
      <mat-datepicker #fromPicker></mat-datepicker>
      <mat-error *ngIf="form.get('validFrom')?.hasError('min')">Date must be today or later</mat-error>
      <mat-hint *ngIf = "validFromAutoUpdate">ValidFrom updated due to change in Price/Type</mat-hint>
    </mat-form-field>

    <!-- Valid To -->
    <mat-form-field appearance="outline" class="half-width">
      <mat-label>Valid To</mat-label>
      <input matInput [matDatepicker]="toPicker" [min]="minDate" formControlName="validTo" />
      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
      <mat-datepicker #toPicker></mat-datepicker>
      <mat-error *ngIf="form.get('validTo')?.hasError('min')">Date must be today or later</mat-error>
    </mat-form-field>

    <!-- Buttons -->
    <div class="form-actions full-width">
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Submit</button>
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
    </div>
  </form>
</div>
